export const PGWheelRewardType = {
  RealMoney: 0,
  FreeBet: 1,
};
